var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMeestShopping = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3045_31960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 68,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H0v68h68V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3045_31960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 0H0v68h68V0Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.381 24.841c0-1.209 2.248-.82 2.93-.545l.21-2.01c-2.279-.705-5.813-.179-5.808 2.82-.046 2.958 4.31 2.554 4.31 3.962 0 1.486-3.414.725-4.155.274l-.388 2.011c2.535 1.12 7.35.872 7.222-2.492-.044-3.262-4.32-2.684-4.32-4.02m-5.797 1.045c0-2.624-3.54-2.66-3.514 0h3.514Zm-3.534 2.03c.185 2.324 3.804 1.921 5.371 1.426l.389 2.01c-3.663 1.402-8.55.489-8.55-4.275 0-6.35 9.076-7.04 9.076-.33 0 .507-.057.956-.096 1.17h-6.19Zm12.726-3.62h1.397v3.992c0 2.098.529 3.663 2.848 3.663.839 0 1.53-.21 1.922-.367V29.34c-1.385.26-2.06.347-2.06-1.5v-8.22h-2.71v2.664h-1.186l-.211 2.01Zm4.568 0h1.597l.555-1.014-.548-.997h-1.604v2.011Zm-35.438 7.458 2.363-9.468.633 9.668h2.653l-.81-12.33h-4.14l-2.03 8.287-2.03-8.288h-4.139L9.6 31.953h2.652l.634-9.667 2.362 9.468h2.66ZM30.041 25.887c0-2.624-3.54-2.66-3.515 0h3.515Zm-3.535 2.03c.186 2.324 3.805 1.92 5.372 1.425l.389 2.011c-3.664 1.402-8.55.488-8.55-4.275 0-6.35 9.076-7.04 9.076-.33 0 .506-.058.955-.096 1.169h-6.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.386 19.621 2.017 3.66-2.017 3.68h-2.01l2.015-3.68-2.015-3.66h2.01ZM17.267 39.82v8.414H15.33v-6.827h-3.798v6.827H9.597V39.82h7.67ZM18.77 44.028c0-2.5 1.947-4.352 4.603-4.352 2.656 0 4.604 1.839 4.604 4.352 0 2.513-1.96 4.351-4.604 4.351s-4.604-1.851-4.604-4.351Zm7.236 0c0-1.599-1.13-2.693-2.632-2.693-1.502 0-2.633 1.093-2.633 2.693 0 1.599 1.13 2.693 2.633 2.693 1.502 0 2.632-1.094 2.632-2.693ZM40.587 39.82v8.414H29.48V39.82h1.936v6.829h2.656v-6.829h1.935v6.829h2.645v-6.829h1.935ZM49.11 41.407h-2.693v6.827h-1.923v-6.827h-2.681v-1.588h7.297v1.588ZM55.613 46.431h-3.907l-.745 1.804h-1.995l3.75-8.415h1.924l3.763 8.415h-2.044l-.746-1.804ZM55 44.953l-1.334-3.222-1.334 3.222H55Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMeestShopping);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/meest-shopping.19b5e7df21566e85240f8ed363459bbc.svg";